module.exports = __webpack_public_path__ + "static/media/2017Earthfest3.fa4e1409.jpg";